import { render, staticRenderFns } from "./NeuralWaveBackground.vue?vue&type=template&id=7bd9064e&scoped=true"
import script from "./NeuralWaveBackground.vue?vue&type=script&lang=js"
export * from "./NeuralWaveBackground.vue?vue&type=script&lang=js"
import style0 from "./NeuralWaveBackground.vue?vue&type=style&index=0&id=7bd9064e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd9064e",
  null
  
)

export default component.exports